/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindTraceabilityGraphByProductIdQueryResponse,
  FindTraceabilityGraphByProductIdPathParams,
} from "../types/FindTraceabilityGraphByProductId.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findTraceabilityGraphByProductIdQueryKey = (
  productId: FindTraceabilityGraphByProductIdPathParams["productId"] | undefined
) =>
  [
    {
      url: "/v1/operation/find-traceability-graph-by-product-id/:productId",
      params: { productId: productId },
    },
  ] as const

export type FindTraceabilityGraphByProductIdQueryKey = ReturnType<
  typeof findTraceabilityGraphByProductIdQueryKey
>

/**
 * @description Returns a discriminated union of operation and launched source-context nodes for the brand product graph.
 * @summary Find traceability graph by product id
 * {@link /v1/operation/find-traceability-graph-by-product-id/:productId}
 */
export async function findTraceabilityGraphByProductId(
  productId: FindTraceabilityGraphByProductIdPathParams["productId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindTraceabilityGraphByProductIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/operation/find-traceability-graph-by-product-id/${productId}`,
    ...requestConfig,
  })
  return res
}

export function findTraceabilityGraphByProductIdQueryOptions(
  productId:
    | FindTraceabilityGraphByProductIdPathParams["productId"]
    | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findTraceabilityGraphByProductIdQueryKey(productId)
  return queryOptions<
    ResponseConfig<FindTraceabilityGraphByProductIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindTraceabilityGraphByProductIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!productId,
    queryKey,
    queryFn: async ({ signal }) => {
      return findTraceabilityGraphByProductId(productId!, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Returns a discriminated union of operation and launched source-context nodes for the brand product graph.
 * @summary Find traceability graph by product id
 * {@link /v1/operation/find-traceability-graph-by-product-id/:productId}
 */
export function useFindTraceabilityGraphByProductId<
  TData = ResponseConfig<FindTraceabilityGraphByProductIdQueryResponse>,
  TQueryData = ResponseConfig<FindTraceabilityGraphByProductIdQueryResponse>,
  TQueryKey extends QueryKey = FindTraceabilityGraphByProductIdQueryKey,
>(
  productId:
    | FindTraceabilityGraphByProductIdPathParams["productId"]
    | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindTraceabilityGraphByProductIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findTraceabilityGraphByProductIdQueryKey(productId)

  const query = useQuery(
    {
      ...findTraceabilityGraphByProductIdQueryOptions(productId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
